import * as path from 'node:path';
import { resolveRepoPathRelativeToWorkspaceRoot } from '../../git/changes/repo/resolve-repo-path-relative-to-workspace-root.js';
import { forEachWithGitYield } from '../../git/git-runtime.js';
import { isGitRepoDirectory } from '../../git/is-git-repo.js';

export async function resolveIsolatedCheckoutForRepoPathRelativeToWorkspaceRoot(options: {
  checkoutPaths: string[];
  sessionParentPath: string | null;
  bridgeRoot: string;
  repoPathRelativeToWorkspaceRoot: string;
}): Promise<string | null> {
  const { checkoutPaths, sessionParentPath, bridgeRoot, repoPathRelativeToWorkspaceRoot } = options;
  const resolvedSessionParentPath = sessionParentPath ? path.resolve(sessionParentPath) : null;

  let match: string | null = null;
  await forEachWithGitYield(checkoutPaths, async (checkoutPath) => {
    if (match) return;
    const resolvedCheckoutPath = path.resolve(checkoutPath);
    if (!(await isGitRepoDirectory(resolvedCheckoutPath))) return;
    const resolvedRepoPathRelativeToWorkspaceRoot = await resolveRepoPathRelativeToWorkspaceRoot({
      checkoutPath: resolvedCheckoutPath,
      bridgeRoot,
      sessionParentPath: resolvedSessionParentPath,
    });
    if (resolvedRepoPathRelativeToWorkspaceRoot === repoPathRelativeToWorkspaceRoot) {
      match = resolvedCheckoutPath;
    }
  });
  return match;
}
